module.exports = __webpack_public_path__ + "static/media/emoha-logo.7f7e20ce.png";